import React from "react";
import { useTableSavedViews } from "../hooks/useTableSavedViews";
import TableSavedViewsControl from "./TableSavedViewsControl";
import { getDataHeaders } from "../utils/tableViewConfig";

/**
 * Drop-in toolbar control + hook results for list tables.
 * Renders the Views dropdown and exposes table layout state via render prop or spread.
 */
const TableSavedViewsToolbar = ({
  pageKey,
  allHeaders,
  fixedPrefixCount = 2,
  defaultStickyColumnKeys,
  getExtraConfig,
  onApplyConfig,
  enabled = true,
  className = "",
  children,
}) => {
  const tableViews = useTableSavedViews({
    pageKey,
    allHeaders,
    fixedPrefixCount,
    defaultStickyColumnKeys,
    getExtraConfig,
    onApplyConfig,
    enabled,
  });

  const control = (
    <TableSavedViewsControl
      className={className}
      controlLabel={tableViews.controlLabel}
      views={tableViews.views}
      activeView={tableViews.activeView}
      loading={tableViews.loading}
      error={tableViews.error}
      isDirty={tableViews.isDirty}
      allDataHeaders={getDataHeaders(allHeaders, fixedPrefixCount)}
      dataHeaders={tableViews.dataHeaders}
      onSelectView={tableViews.selectView}
      onSaveNew={tableViews.saveNewView}
      onUpdateActive={tableViews.updateActiveView}
      onRename={tableViews.renameView}
      onDelete={tableViews.deleteView}
      onSetDefault={tableViews.setDefaultView}
      onUpdateColumnVisibility={tableViews.updateColumnVisibility}
    />
  );

  if (typeof children === "function") {
    return children({ control, ...tableViews });
  }

  return control;
};

export default TableSavedViewsToolbar;
